import { Route, Switch, useLocation } from 'wouter';
import { Layout } from './components/Layout';
import { DashboardPage } from './pages/DashboardPage';
import { ListPage } from './pages/ListPage';
import { RecordPage } from './pages/RecordPage';
import { CreatePage } from './pages/CreatePage';
import { SettingsPage } from './pages/SettingsPage';
import { FormsPage } from './pages/FormsPage';

export function App() {
  return (
    <Layout>
      <Switch>
        <Route path="/" component={DashboardPage} />
        <Route path="/objects/:type/new" component={CreatePage} />
        <Route path="/objects/:type/:id" component={RecordPage} />
        <Route path="/objects/:type" component={ListPage} />
        <Route path="/forms" component={FormsPage} />
        <Route path="/settings" component={SettingsPage} />
        <Route>
          <NotFound />
        </Route>
      </Switch>
    </Layout>
  );
}

function NotFound() {
  const [, setLocation] = useLocation();
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold mb-2">Page not found</h1>
      <button onClick={() => setLocation('/')} className="btn-primary">
        Back to dashboard
      </button>
    </div>
  );
}
